import { applyMiddleware, compose, createStore } from 'redux';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';

import reducers from '../redux/reducers';

// Use the Redux DevTools compose enhancer if available, otherwise fall back to Redux's compose
// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk, logger))
);

// Optional: subscribe to the store (if needed)
// const unsubscribe = store.subscribe(() => {
//   const state = store.getState();
//   console.log(state);
// });

export default store;
